export default "__VITE_ASSET__CRI8mwjK__"